import React, { Component } from "react";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Col, Image, Row } from "react-bootstrap";
import { deleteCouponApi, getCouponApi } from "./Api";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { connect } from "react-redux";
import CouponForm from "./CouponForm";
import { MODULE_ID_MAP, START_PAGE, Subscription, isModuleExist, subCoupon } from "../../utils/Constant";
import { COUPON_VERIFY } from "../../utils/urls";
import editPencil from "../../assets/images/edit-icon.png";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";

export class CouponTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.SubscriptionCoupon);

    this.state = {
      access: AccesData,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,
      verified: '',
      verifyUrl: ''
    };
  }
  // todo---------------------------------------
  componentDidMount() {
    const { history } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getCouponApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSize = prevParams.get("pageSize") || "";
    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = params.get("pageSize") || "";
    if (prevPage !== page || prevVerified !== verified || prevParams.get("search") !== params.get("search") || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getCouponApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {

    deleteCouponApi(id, this, this.openCloseDeleteModal)
  }

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;

    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete ${this.state.deleteData.couponCode} Coupon?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}
        <VerifiedModal
          name={`'${this.state.editData?.couponCode}'`}
          show={this.state.show}
          url={COUPON_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getCouponApi(this) }}
        />
        {
          showEdit &&
          <CouponForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Coupon"
          breadcrumb={[["Subscription", ""], ["Coupon", ""]]}
          primaryBtn={access.createAccess ? "Add Coupon" : ""}
          handlePrimaryBtn={() => {
            
            this.setState({ showEdit: true })
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">

          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[
              {
                width: 200,
                title: "Coupon Code Name",
                dataIndex: "couponCode",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.couponCode;
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },
              {
                width: 150,
                title: "Flat/Percentage",
                dataIndex: "isPercentage",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.isPercentage ? "Percentage" : "Flat";
                },
              },
              {
                width: 150,
                title: "Discount",
                dataIndex: "discountAmount",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.discountAmount || (rowData.discountPercentage + "%")
                },
              },


              {
                width: 100,
                title: "Max-Limit",
                dataIndex: "maxLimit",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.maxLimit;
                },
              },
              {
                width: 150,
                title: "User Max Time Use",
                dataIndex: "userMaxTimeUse",
                className: "",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.userMaxTimeUse;
                },
              },
              {
                width: 150,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.updatedBy?.name || 'Na';
                },
              },
              {
                width: 150,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.createdBy?.name || 'Na';
                },
              },
              {

                width:20,
                title: "Action",
                dataIndex: "",
                className: "",
                fixed:"right",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      // <div className="d-flex gap-4 justify-content-around">
                      //   {access.updateAccess && (
                      //     <Image src={editIcon} className="edit-icon" onClick={() => { this.showEditModal(rowData) }} />
                      //   )}
                      //   {access.deleteAccess && (
                      //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                      //   )}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess ? () => { this.showEditModal(rowData) } : null}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        ></OptionsDropdown>
                    );
                  }

              }

            ]}

            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}


const mapStateToProps = state => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getCouponApi
}

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CouponTab));
